module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title5"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("E")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ea:")]), _vm._v(" In Babylonian and Assyrian mythology, the god of waters and of wisdom, crafts and learning, especially of the magical arts; the third member of the Babylonian triad of gods (Anu, Enlil, Ea).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Earth signs:")]), _vm._v(" In astrology, this term is applied to the signs of the Earth Triplicity: Taurus, Virgo, Capricorn. The ancients symbolized these types by the Earth element, because of their predominant “Earthiness” or practicality.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eating the god:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sacramental meal; theophagy.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ecstasis:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ecstasy.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ecstasy:")]), _vm._v(" A state of rapture in which visions of the invisible world unfold; a shift of human perception from the material world to the spiritual realm. Usually said to be concomitant with a spiritual union with higher reality.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ectenic force:")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Psychic force")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ectoplasm:")]), _vm._v(" A term coined by Professor Richet (a contraction of the Greek words "), _c('em', {
    staticClass: "i"
  }, [_vm._v("ektos,")]), _vm._v(" exteriorized, and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("plasma,")]), _vm._v(" substance) for the mysterious protoplasmic substance which streams forth from the bodies of mediums, producing super-physical phenomena, including materializations, under manipulation by a discarnate intelligence. Ectoplasm is described as matter which is invisible and impalpable in its primary state, but assuming the state of a vapor, liquid or solid, according to its stage of condensation. It emits an ozone-like smell. The ectoplasm is considered by spiritualists to be the materialization of the astral body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eddas:")]), _vm._v(" The heroic literature of the old Norse, written in Old Icelandic (12th–13th centuries A.D.); our chief source of knowledge of Norse mythology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Effluvium theory; efflux theory:")]), _vm._v(" A theory of early Greek thinkers that perception is mediated by "), _c('em', {
    staticClass: "i"
  }, [_vm._v("effluvia")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("simulacra")]), _vm._v(" projected by physical objects and impinging upon the organs of sense. Thus Empedocles developed the theory of effluxes in conjunction with the principle that “like perceives only like” ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("similia similibus percipiuntur")]), _vm._v(" ), that an element in the external world can only be perceived by the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("same")]), _vm._v(" element in the body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Efreet:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Afreet.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ego:")]), _vm._v(" The consciousness of being oneself. According to the teachings of esoteric philosophy, two Egos co-exist in man: the mortal, personal Ego which it calls "), _c('em', {
    staticClass: "i"
  }, [_vm._v("personality,")]), _vm._v(" and the divine, impersonal Ego which it designates as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("individuality.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Egoity:")]), _vm._v(" In occult terminology, a synonym of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("individuality")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eidolism:")]), _vm._v(" The body of the belief about disembodied entities, ghosts, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eidolon:")]), _vm._v(" Greek name for the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kama Rupa")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eileithya:")]), _vm._v(" A goddess of prehistoric Crete (mentioned by Homer); one of her cave temples was discovered at Amnisos (Candia).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ekam adwaitam:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("the One without a second;")]), _vm._v(" the famous definition of God in the Chandogya Upanishad.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elder brother:")]), _vm._v(" A member of the Great White Lodge (q.v.), a high initiate in occultism and esoteric sciences whose efforts and diligence have made him attain a higher degree of spiritual evolution than the ordinary student of occultism. Referred to in occult literature also as Adept, Great Initiate, Master, Master Occultist, Master of Wisdom, or Rishi.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eledion of days:")]), _vm._v(" In occultism, especially in astrology, the determination of the day or days on which a certain act can be most advantageously performed. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("electional astrology")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Electional astrology:")]), _vm._v(" An astrological method, the aim of which is to permit the choice of a suitable time for commencing any honestly conceived and reasonable project or endeavor, such as a marriage, journey, law-suit, building operation, engaging in a new business or profession, the reconciling of opponents, drawing up a will, buying land or house, planting a garden, launching a ship, or moving into a new home.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Element:")]), _vm._v(" According to occult philosophy, the four elements of the material world are Air, Earth, Fire and Water (symbolizing, respectively, the gaseous, solid and liquid states and heat or energy).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elemental:")]), _vm._v(" A spirit evolved in and from, and inhabiting, one of the four elements—a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("sylph")]), _vm._v(" (spirit of the air), a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gnome")]), _vm._v(" (spirit of the earth), a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("salamander")]), _vm._v(" (spirit of the fire), or an "), _c('em', {
    staticClass: "i"
  }, [_vm._v("undine")]), _vm._v(" (spirit of the water). Occultists regard elementals as beings having substance, but visible only to those who have inner sight; some elementals are regarded benign, others as malignant. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("elemental essence")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elemental essence:")]), _vm._v(" According to occultism, a substance existing on the subtler planes (q.v.), which concentrated thought or desire can mold into entities called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("elementals")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elementaries:")]), _vm._v(" In occult terminology, the astral corpses of the dead. An Elementary is the ethereal counterpart of the person no longer alive; as the physical body is dissolved into the elements to which it belongs, also the Elementary is decomposed into its astral elements. Elementaries of good persons decompose soon, while those of the wicked may exist for a long time. Theosophy uses the word Elementary in the meaning of “the disembodied souls of the depraved.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elementary spirit:")]), _vm._v(" An elemental (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eleusinian mysteries:")]), _vm._v(" The oldest of all Greek mysteries, known to have been performed as early as the 19th century B.C. They were held in the vicinity of Eleusia, near Athens. They honored the mother-goddess Demeter and her daughter Persephone who was abducted by Hades into the underworld and later was restored to Demeter by Zeus for eight months in each year. Thus, the rites seem to have originated as agrarian ceremonies to insure divine help for the fertility and productivity of the soil, Demeter symbolizing the earth and Persephone the seed. Later, the rites took on an occult significance, were ascribed the power to insure happiness in the world after death, and the power to give the initiate true enlightenment and understanding in this life and on the next plane of existence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elf:")]), _vm._v(" A wandering nature-spirit appearing in unfrequented places; elves are believed to appear in tiny human forms, and generally to be mischievous, often benevolent and helpful.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elf-fire:")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ignis fatuus")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elfin:")]), _vm._v(" Elf-like, fairy-like; relating or pertaining to elves.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elixir of life:")]), _vm._v(" The substance sought by the alchemists, as one that can extend life indefinitely and transmute base metals into gold.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elohim:")]), _vm._v(" A Semitic word for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gods;")]), _vm._v(" in Judaism, the name used instead of the ineffable name, Yahveh or Jehovah, of the One God.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elongation:")]), _vm._v(" A mediumistic phenomenon, observed at several seances, consisting in a lengthening of the body of the medium, attributed by the spiritualists to the action of spirits of the dead.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elysian Fields; Elysium:")]), _vm._v(" In classical mythology, the place in the underworld which was the abode of the souls of the righteous after their death.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Emanation:")]), _vm._v(" The psychic force or effluence, often described also as a radiation or vibration of magnetic force, said to issue forth from all physical bodies and objects and surround them like a halo or aura.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Emanation doctrine:")]), _vm._v(" The occultist doctrine of emanation teaches that nothing can be evolved without first being involved —meaning that evolution as a way of embryonic development and eventual birth of the individual is secondary to spiritual power, the guidance by intelligent forces.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Emma-O:")]), _vm._v(" In Japanese Buddhism, the god who is the ruler of the underworld and judges the dead.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Emotional body:")]), _vm._v(" A synonym used by many occult authors for the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Empathy:")]), _vm._v(" The projection by the mind into an object of the subjective feeling of bodily posture and attitude which result from the tendency of the body to conform to the spatial organization of the object (e.g., the tendency to imitate the outstretched hands of a statue).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Empirical:")]), _vm._v(" Based on observation, experience or experiment.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("En-Soph:")]), _vm._v(" The Limitless Deity of early Hebrew metaphysicists, interpreted as the “Supreme God” of the modern Kabalists.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Enchiridion:")]), _vm._v(" A collection of magical prescriptions and incantations for protection against illness and misfortune, dating from the ninth century A.D.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Enki:")]), _vm._v(" The Sumerian god of the earth, sweet waters, wisdom and profundity of mind. He was sometimes identified with Ea.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Enlil:")]), _vm._v(" The Sumerian and Babylonian god of wind and storm, second of the Babylonian triad of gods (the other two were Anu and Ea).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ennead:")]), _vm._v(" In numerology, the number Nine.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Entered apprentice:")]), _vm._v(" In Freemasonry, one who has been given the first degree of initiation.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ephemeris")]), _vm._v(" (plural: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("ephemerides")]), _vm._v("). An almanac listing the ephemeral or rapidly changing position which each of the bodies of the solar system will occupy on each day of the year: their longitude, latitude, declination, and similar astronomical phenomena. A set of ephemerides which includes the year of the native’s birth, is essential in the erection of a horoscope. The astronomer’s ephemeris lists these positions in heliocentric terms; that of the astrologer, in geocentric terms.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Epiphenomenalism:")]), _vm._v(" A materialistic theory, which holds that consciousness is, in relation to the neural processes which underlie it, a mere "), _c('em', {
    staticClass: "i"
  }, [_vm._v("epiphenomenon")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Epiphenomenon:")]), _vm._v(" A by-product of a basic process which exerts no appreciable influence on the subsequent development of the process.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Epistemology:")]), _vm._v(" That branch of philosophy which investigates the origin, structure, methods and validity of knowledge.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Epopteia:")]), _vm._v(" The advanced degree of initiation in the Eleusinian mysteries.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Erh:")]), _vm._v(" A Chinese term designating the active or male principle ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("yang")]), _vm._v(") and the passive or female principle ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("yin")]), _vm._v("), which are the products of Tao and which produce the myriad of things.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Erodinium:")]), _vm._v(" A vision or symbolic dream; a pictorial or allegorical representation of some future event.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eros:")]), _vm._v(" In Platonism, the driving force of life aspiring to the absolute Good.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eschatology:")]), _vm._v(" That part of systematic or dogmatic theology dealing with the last things, namely, death, judgment, heaven and hell, and also with the end of the world. Also applied by philosophers to the complexus of theories relating to the ultimate end of mankind and the final stages of the physical cosmos.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Esoteric:")]), _vm._v(" Secret, not accessible to the uninitiated. When such information is published it ceases to be esoteric and becomes "), _c('em', {
    staticClass: "i"
  }, [_vm._v("exoteric,")]), _vm._v(" which means that the facts have become the property of the rest of humanity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Esoteric Buddhism:")]), _vm._v(" The mystic or occultistic schools of Buddhism. Specifically, Lamaism (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Esoteric language:")]), _vm._v(" Any artificial "), _c('em', {
    staticClass: "i"
  }, [_vm._v("mystery language")]), _vm._v(" (q.v.) invented and used by initiates for the safeguarding of their secrets.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Esoteric Sciences:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Occult Sciences")]), _vm._v(" (q.y.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Esotericism:")]), _vm._v(" The secret or occult doctrines or sciences; belief in or practice of such doctrines or sciences.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Esoterism:")]), _vm._v(" Occult or esoteric character or property. Also, a synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("esoteric science.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ESP:")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Extrasensory perception")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Esse est percipi:")]), _vm._v(" Latin for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("to be is to be perceived.")]), _vm._v(" The maxim formulated by Bishop George Berkeley (1685–1753) expressing that a material world of bodies does not exist except in perceptibility—that things cannot exist unless perceived by some mind, and therefore only mind (divine mind) and mental content (ideas) exist.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Essence:")]), _vm._v(" That by which a thing is what it is, as distinguished from the thing’s existence, properties or attributes.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eternity:")]), _vm._v(" An infinite extent of time, in which every event is future at one time, present at another, past at another. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("future.")]), _vm._v(" )")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ether:")]), _vm._v(" The substance which, according to occultism, fills all space and pervades all matter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Etheric double:")]), _vm._v(" In occult terminology, the invisible vehicle of the soul, the manifestation of physical vitality; it is constant and does not change throughout the cycles of life and death, but it is not eternal, for it is eventually re-absorbed into the elements of which it is composed. It is considered the invisible part of the physical body, extending slightly beyond the latter and able to combine with other subtle substance. Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("vital body")]), _vm._v(" or, in Sanskrit, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("lingasharira.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Etheric vision:")]), _vm._v(" In theosophical terminology, the power of vision of the etheric double (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ethics:")]), _vm._v(" That study or discipline which concerns itself with judgments of approval and disapproval, judgments as to the rightness or wrongness, goodness or badness, virtue or vice, desirability or wisdom of actions, dispositions, ends, objects, or states of affairs.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ETP:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Extratemporal perception.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Etz Hayim:")]), _vm._v(" Hebrew for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Tree of Life.")]), _vm._v(" The title of a book by Hayim Vital Calabrese, disciple of Isaak Luria, explaining the Kabalistic system of the latter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eudœmonism:")]), _vm._v(" The Theory, first proposed in Western philosophy by Aristotle, that the aim of the good life is happiness or well-being.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eurhythmy, eurythmy:")]), _vm._v(" An art devised by Rudolf Steiner, the founder of anthroposophy (q.v.), to “translate into movement the rhythm which permeates man and Nature” and to manifest visibly the “inner essence of speech and tone.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Evil eye:")]), _vm._v(" The power of fascination (q.v.) or of harming others by a look.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Evil spirit:")]), _vm._v(" According to spiritualistic philosophy, the spirit of a bad man inhabiting the lower spheres from which it can reach a medium, and may even oust the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("control")]), _vm._v(" (q.v.) of an unwilling medium.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Evocation:")]), _vm._v(" The art or act of summoning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("elementals")]), _vm._v(" (q.v.) or other discarnate entities.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Evolution:")]), _vm._v(" A continuous process of orderly change and development toward a higher or more complex state.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Evolutionism:")]), _vm._v(" The view that the universe and life in all of their manifestations and nature in all of its aspects are the product of development.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Exorcise:")]), _vm._v(" To cast out an evil spirit.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Exorcism:")]), _vm._v(" The expulsion of malevolent spirits or demons from possessed persons, objects or places, by the utterance of an incantation or formula seeking the aid of a more powerful spirit or deity, usually invoked by name. The term is often applied also to any act or ritual, whether or not including the speaking of a formula, by which malevolent spirits are expelled.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Exoteric:")]), _vm._v(" Exposed, visible. Antithesis of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("esoteric")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Externalization:")]), _vm._v(" The mental act by which sensory data originally considered to be internal are projected into the external world.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Externalize:")]), _vm._v(" In astrological parlance, said of the event which transpires when an astrological influence is incited to action by contact with a circumstance of environment. The thought is based upon the theory that astrological influences have to do with the mental and emotional conditioning that determines the nature of the individual’s reaction to circumstances, but that they do not of themselves produce events.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Extra-cosmic:")]), _vm._v(" Outside of the cosmos. According to esoteric philosophy, nothing can be extra-cosmic, because the cosmos (Nature) is infinite and includes everything, and nothing can be outside of it.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Extra-retinal vision:")]), _vm._v(" The faculty, claimed by many occultists and spiritualists to be attainable, of using the skin for seeing, instead of the eyes. It is claimed that this actually constitutes sight with the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("etheric body.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Extrasensory perception (ESP):")]), _vm._v(" A term coined by Dr. J. B. Rhine of Duke University; defined as “response to an external event not presented to any known sense” ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Journal of Parapsychology")]), _vm._v(" ).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Extratemporal perception (ETP):")]), _vm._v(" A newly coined and not as yet generally accepted term for extrasensory perception through time as well as distance in space; the ability to see into the past and the future.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Exuvial magic:")]), _vm._v(" A form of contagious magic (q.v.) in which severed parts of the body of an intended victim (nail parings, strands of hair, etc.) are used by a black magician.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eyeless sight:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Extra-retinal vision.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeeb7836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/e9780806537009_c05.vue
// module id = 87
// module chunks = 0